import { EApiRequestPartKeys, EBitfApiRequestPartsNames } from '@enums';
import { BitfApiRequestPart } from '@bitf/core/api-call-state/bitf-api-request-part';

export class FsSearchApiRequestPart extends BitfApiRequestPart {
  constructor() {
    super(EApiRequestPartKeys.SEARCH, EBitfApiRequestPartsNames.SEARCH);
  }

  build(): void {
    this.part = this.formValue;
  }
}
